<template>
  <!-- 换房 -->
  <a-modal
      v-model:visible="show"
      :confirmLoading="loading"
      title="换房"
      width="800px"
      @cancel="handleClose"
      @ok="handleConfirmChangeRoom"
  >
    <!-- 搜索 -->
    <div class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-select
                v-model:value="searchForm.rid"
                :dropdownMatchSelectWidth="false"
                allowClear
                placeholder="房型"
                @change="getRoomList()"
            >
              <a-select-option value="0">独立房间</a-select-option>
              <a-select-option
                  v-for="item in searchList.room?.list"
                  :key="item.id"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.gid"
                :dropdownMatchSelectWidth="false"
                allowClear
                placeholder="分组"
                @change="getRoomList()"
            >
              <a-select-option
                  v-for="item in searchList.group?.list"
                  :key="item.id"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.hname"
              :loading="loading"
              allowClear
              placeholder="请输入房间名称"
              @search="getRoomList()"
          >
          </a-input-search>
        </div>
      </div>
    </div>

    <div v-if="stockRoomList.length" class="room">
      <div
          v-for="item in stockRoomList"
          :key="item.id"
          class="room-cell"
          @click="selRoomItem = item"
      >
        <div class="cell-left">
          <img
              :src="imgCut(item.image ? item.image : companyLogo, 'xl')"
              alt="房源图片"
              fit="fill"
              style="width: 50px; height: 30px; object-fit: cover"
          />
          <div
              :title="item.name"
              class="t-h-1"
              style="margin-left: 10px; width: 600px"
          >
            {{ item.rname || "独立房间" }} -
            {{ item.name }}
          </div>
        </div>
        <div v-show="selRoomItem.id == item.id" class="cell-right">
          <CheckOutlined style="color: #0094ff; font-size: 20px"/>
        </div>
      </div>
    </div>
    <a-empty v-else :image="simpleImage"/>
  </a-modal>
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";
import {Empty, message} from "ant-design-vue";
import {changeRoom, getSearchList, getStockRoomList, orderBoxCheckRoom,} from "@/api/api";
import {CheckOutlined} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库

export default {
  components: {
    CheckOutlined,
  },
  props: {
    startDate: {
      required: true,
    },
    endDate: {
      required: true,
    },
    orderId: {
      required: true,
    },
    isOrderBox: {
      default: false,
    },
  },
  setup(props, content) {
    let {imgCut} = useUtils();
    let modal = reactive({
      show: true,
      selRoomItem: "",
      stockRoomList: [],
      searchList: [],
      searchForm: {
        rid: [],
        gid: [],
        hname: "",
      },
      loading: false,
      companyLogo: JSON.parse(sessionStorage.getItem("companyInfo") || '{}').logo || '',
      // 获取房间列表
      getRoomList() {
        modal.loading = true;
        getStockRoomList({
          start: 0,
          limit: 999,
          table: 1,
          start_time: props.startDate,
          end_time: props.endDate,
          rid: modal.searchForm.rid,
          gid: modal.searchForm.gid,
          name: modal.searchForm.hname,
        })
            .then((res) => {
              modal.stockRoomList = res.data;
            })
            .finally(() => {
              modal.loading = false;
            });
      },
      // 获取查询参数列表
      getSearch() {
        getSearchList().then((res) => {
          modal.searchList = res.data;
        });
      },
      // 换房确定
      handleConfirmChangeRoom() {
        if (!modal.selRoomItem?.id) {
          message.error("请选择房间");
          return;
        }
        modal.loading = true;
        if (props.isOrderBox) {
          orderBoxCheckRoom({
            order_id: props.orderId,
            hid: modal.selRoomItem.id,
          })
              .then((res) => {
                message.success(res.msg);
                content.emit("confirmChangeRoom");
                content.emit("closeChangeRoom");
              })
              .finally(() => {
                modal.loading = false;
              });
        } else {
          changeRoom({
            order_id: props.orderId,
            hid: modal.selRoomItem.id,
          })
              .then((res) => {
                message.success(res.msg);
                content.emit("confirmChangeRoom");
                content.emit("closeChangeRoom");
              })
              .finally(() => {
                modal.loading = false;
              });
        }
      },
      handleClose() {
        content.emit("closeChangeRoom");
      },
    });
    onMounted(() => {
      modal.getRoomList();
      modal.getSearch();
    });

    return {
      ...toRefs(modal),
      imgCut,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
};
</script>

<style lang="scss">
.room {
  border: 1px solid #f3f3f3;
  overflow-y: scroll;
  max-height: 500px;

  .room-cell {
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f3f3f3;

    &:hover {
      background-color: #f2f2f277;
    }

    &:last-child {
      border-bottom: none;
    }

    .cell-left {
      display: flex;
      align-items: center;
    }

    .cell-right {
    }
  }
}
</style>